module.exports = __webpack_public_path__ + "img/ideal.91c86f1c.svg";